import React from "react";
import "../styles/appstore.css";
import { Link } from "react-router-dom";
import apps from "../applications.json";

interface App {
  name: string;
  title: string;
  imgSrc: string;
  category: string;
  platforms: string[];
  web: string;
}

const categoryOrder = ["Diet & Nutrition", "Fitness", "Health & Wellness"];

const categoryIcons: Record<string, string> = {
  "Diet & Nutrition": "🥗",
  "Fitness": "💪",
  "Health & Wellness": "❤️‍🩹",
};

const appImages = require.context(
  "../assets/appstore",
  false,
  /\.(png|jpe?g|svg)$/
);

const Appstore = () => {
  const grouped = (apps as App[]).reduce(
    (acc, app) => {
      if (!acc[app.category]) acc[app.category] = [];
      acc[app.category].push(app);
      return acc;
    },
    {} as Record<string, App[]>
  );

  return (
    <div className="appstore">
      <div className="appstore__header">
        <h1 className="appstore__title">Apps</h1>
        <p className="appstore__subtitle">
          Builds & web links for all projects
        </p>
      </div>

      {categoryOrder.map((category) => {
        const categoryApps = grouped[category];
        if (!categoryApps) return null;
        return (
          <section key={category} className="appstore__section">
            <h2 className="appstore__section-title">
              <span className="appstore__section-icon">
                {categoryIcons[category]}
              </span>
              {category}
              <span className="appstore__section-count">
                {categoryApps.length}
              </span>
            </h2>

            <div className="appstore__grid">
              {categoryApps.map((app, index) => {
                const image = appImages(`./${app.imgSrc}`);
                return (
                  <div
                    key={app.name}
                    className="appstore__card"
                    style={{ animationDelay: `${index * 0.04}s` }}
                  >
                    <img
                      src={image}
                      alt={app.title}
                      className="appstore__card-icon"
                    />
                    <span className="appstore__card-name">{app.title}</span>

                    <div className="appstore__card-links">
                      {app.platforms.includes("ios") && (
                        <Link
                          to={`/updraft?app=${app.name}&platform=ios`}
                          className="appstore__link"
                          title={`${app.title} — iOS build`}
                        >
                          <span className="appstore__platform-badge ios" />
                          iOS
                        </Link>
                      )}
                      {app.platforms.includes("android") && (
                        <Link
                          to={`/updraft?app=${app.name}&platform=android`}
                          className="appstore__link"
                          title={`${app.title} — Android build`}
                        >
                          <span className="appstore__platform-badge android" />
                          Android
                        </Link>
                      )}
                      <a
                        href={app.web}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="appstore__link appstore__link--web"
                        title={`${app.title} — Website`}
                      >
                        <svg
                          className="appstore__web-icon"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <circle cx="12" cy="12" r="10" />
                          <path d="M2 12h20" />
                          <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                        </svg>
                        Web
                      </a>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default Appstore;
